<ng-template #content let-c="close" let-d="dismiss">
	<div class="modal-header" [hidden]="!alertHeader">
		<h4 class="modal-title">{{alertTitle}}</h4>
		<div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close" (click)="d('Close click')">
			<i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
		</div>
	</div>
	<div class="modal-body">
		<div class="fs-3" [hidden]="!alertMessage">
			<span style="white-space: pre-line;" [innerHTML]="message"></span>
			 @if (displayItems.length) {
				<ul class="fs-5">
					<li *ngFor="let displayItem of displayItems;">{{displayItem}}</li>
				</ul>
			 }
		</div>
	</div>
	<div class="modal-footer" [hidden]="!alertFooter">
		<span [hidden]="!cancelButton">
			<button type="button" class="btn btn-secondary" (click)="d('Close click')">{{cancelButtonText}}</button>
		</span> 
		<span [hidden]="!okButton">
			<button type="button" class="btn btn-primary" (click)="c('Close click')">{{okButtonText}}</button>
		</span> 
	</div>
</ng-template>
